import { toRefs, reactive } from "vue";

import axios from "axios";
import config from "../../config"
import { getAuthToken, logout as authLogout, saveAuthToken } from "./auth";




const state = reactive({
    initialized: false,
    initializing: false,
    error: null,
    customerId: null,
    customer: null,
    registrationRequest: null
});


if (!state.initialized && !state.initializing) {
    state.initializing = true;
    state.initialized = true
    state.initializing = false
}

function reset() {
    state.error = null
    state.customerId = null
    state.customer = null
    state.registrationRequest = null


}


async function loadLoggedInCustomer(companyId) {

    reset()

    //get the permanent authtoken (if there is one)
    let token = getAuthToken(companyId)

    //check if there is a  signin-token embedded in the url if yes use that

    const urlParams = new URLSearchParams(window.location.search);


    let hasTokenInUrl = urlParams && urlParams.get('token')
    token = hasTokenInUrl ? urlParams.get('token') : token;

    if (token) {
        try {
            let response = await axios.get(config.apiUrl + "/api/frontend/customers/check-token", {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            });
            if (response && response.data) {

                console.log('response',response)
                let customer = response.data.customer
                //if the result has an id save it as user
                if (customer) {
                    state.customer = customer
                    state.customerId = customer.id || null
                }

                let registrationRequest = response.data.registrationRequest
                //if the result has an id save it as user
                if (registrationRequest) {
                    state.registrationRequest = registrationRequest
                    state.registrationRequest.token = token
                }

                // save/replace any new token the server returned
                if (response.data.token) {
                    console.log("Found Auth token", response.data.token)                    
                    saveAuthToken(companyId, response.data.token)
                }
            }

            //if the user used an url with embedded token then redirect to a clean url
            if (state.customerId && hasTokenInUrl) {
                removeTokenFromUrl()
            }

        } catch (error) {
            console.log('@customerService@loadLoggedInCustomer: ', error)
        }
    }
}

async function sendLoginCode(companyId, email, pointofsaleId) {

    state.customer = null
    state.customerId = null

    if (companyId && email) {
        try {
            let response = await axios.post(config.apiUrl + "/api/frontend/customers/send-login-token", {
                companyId: companyId,
                email: email,
                //the point of sale the customer is sitting at right now (e.g. "Room 62"),
                //so the mailed login link brings them back here instead of the default one
                pointofsaleId: pointofsaleId || null
            });
            if (response && response.data) {
                return response.data
            }

        } catch (error) {
            console.log('@customerService@sendLoginCode: ', error)
        }
    }
    return null
}

export function removeTokenFromUrl() {
    var currURL = window.location.href;
    var url = (currURL.split(window.location.host)[1]).split("?")[0];
    window.history.pushState({}, document.title, url);
}

async function completeRegistration(companyId, data) {

    state.customer = null
    state.customerId = null

    let token = state.registrationRequest && state.registrationRequest.token
    let acceptedTerms = data && data.acceptedTerms

    if (token && acceptedTerms) {
        try {
            let response = await axios.post(config.apiUrl + "/api/frontend/customers/complete-registration",
                data,
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                });

            if (response && response.data) {

                // save the new new token the server returned
                if (response.data.token) {
                    console.log("Found Auth token", response.data.token)                    
                    saveAuthToken(companyId, response.data.token)
                }


                //remove the token
                removeTokenFromUrl()
                //load the new user

                await loadLoggedInCustomer(companyId)
                return response.data
            }
        } catch (error) {
            console.log('@customerService@sendLoginCode: ', error)
        }
    } else {
        console.error("Called completeRegistration without token or acceptedTerms", token, completeRegistration)
    }
    return null
}

async function updateAddresses(companyId, data) {
    let token = getAuthToken(companyId)
    if (!token) {
        return { errors: { global: ['not-authenticated'] } }
    }

    try {
        let response = await axios.post(config.apiUrl + "/api/frontend/customers/update-addresses",
            {
                billingAddress: data && data.billingAddress ? data.billingAddress : null,
                deliveryAddress: data && data.deliveryAddress ? data.deliveryAddress : null,
                deliveryUsesDifferentAddress: Boolean(data && data.deliveryUsesDifferentAddress),
            },
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            });

        if (response && response.data) {
            if (response.data.customer) {
                state.customer = response.data.customer
                state.customerId = response.data.customer.id || null
            }
            return response.data
        }
    } catch (error) {
        console.log('@customerService@updateAddresses: ', error)
        return { errors: { global: ['update-addresses-failed'] } }
    }
    return null
}

async function fetchOrders(companyId) {
    let token = getAuthToken(companyId)
    if (!token) {
        return { orders: [] }
    }
    try {
        let response = await axios.get(config.apiUrl + "/api/frontend/customers/orders", {
            headers: {
                Authorization: 'Bearer ' + token
            }
        });
        if (response && response.data && Array.isArray(response.data.orders)) {
            return { orders: response.data.orders }
        }
    } catch (error) {
        console.log('@customerService@fetchOrders: ', error)
    }
    return { orders: [] }
}


function logout() {
    if (state.customer && state.customer.companyId) {
        authLogout(state.customer.companyId)
    }
    reset()
}

function cancelRegistration() {
    this.logout()
}

export default {
    ...toRefs(state),
    loadLoggedInCustomer,
    sendLoginCode,
    cancelRegistration,
    completeRegistration,
    removeTokenFromUrl,
    updateAddresses,
    fetchOrders,
    logout

}

